// eslint-disable-next-line import/no-cycle
import { loadRequests, changeRequestStatus } from '@/services/repository';

import { LOAD_PROJECTS } from '@/store/project/actionTypes';
import { LOAD_REQUESTS, CHANGE_REQUESTS_LIST_OPTIONS, CHANGE_REQUEST_STATUS } from '@/store/request/actionTypes';
import { createRunMutationAction } from '@/store/utils';
import { SET_REQUESTS, CLEAR_REQUESTS, SET_REQUESTS_LIST_OPTIONS } from './mutationTypes';

export default {
  async [LOAD_REQUESTS]({ commit, getters }) {
    try {
      const { items: requests } = await loadRequests(getters.requestListOptions);
      commit(SET_REQUESTS, requests);
    } catch (e) {
      commit(CLEAR_REQUESTS);
    }
  },
  [CLEAR_REQUESTS]: createRunMutationAction(CLEAR_REQUESTS),
  async [CHANGE_REQUESTS_LIST_OPTIONS]({ commit, dispatch }, options) {
    commit(SET_REQUESTS_LIST_OPTIONS, options);

    await dispatch(LOAD_REQUESTS);
  },
  async [CHANGE_REQUEST_STATUS]({ dispatch }, options) {
    await changeRequestStatus(options.id, options.status);
    await dispatch(LOAD_REQUESTS);
    await dispatch(LOAD_PROJECTS);
  },
};
